/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const initData = {
    general: {
        WorkDate: '',
        MDCD: '',
        MDName: '',
        OfficeCD: '',
        OfficeName: '',
        WorkReportTitle: '',
        DayCount: '',
        EmployeeCD: '',
        UserName: '',
        WorkDetail: '',
        Comment: '',
        ProcessImprovement: '',
        PlannedActionsTime: '',
        PlannedActionsPlace: '',
        Issues: ''
    },
    time_schedule: [
        {
            WorkTime: '',
            WorkType: '',
            WorkDetail: ''
        }
    ],
    sites: [],
    type_header: 1,
    type: '1',

    //mockup data
    department_action_plan: '',
    department_progress_report: '',
    date_of_occurrence: '2025/08/01',
    occurrences_fiscal_year: '10',
    sales_budget_all_company: '3300000000',
    sales_budget_west_japan: '1000000000',
    arrangement_budget_west_japan: '64516',
    arrangement_budget_group_1: '31048',
    arrangement_budget_group_2: '27089',
    arrangement_budget_tennoji: '12364',
    arrangement_budget_namba: '8369',
    arrangement_budget_nishi_kujo: '8369',
    arrangement_budget_kobe: '7800',
    arrangement_budget_himeji: '1317',
    arrangement_budget_umeda: '12838',
    arrangement_budget_osaka_nishi_amagasaki: '1825',
    arrangement_budget_kyobashi: '5734',
    arrangement_budget_kyoto: '4947',
    arrangement_budget_shiga: '1745',
    arrangement_budget_creative: '1584',
    arrangement_budget_outsourcing_count: '530',
    arrangement_budget_sporty: '3905',
    west_japan: '360',
    //data for type 2
    office_arrangement_progress: '25期受注・手配進捗 - Google スプレッドシート',
    arrangement_intention: '本日手配した中の手配意図で共有すべき内容を記入。手配サイドからの教育・育成したいスタッフなど',
    other: '現場前、現場後に他業務をした際はこちらに記載',
    action_plan_date: '2025/09/01',
    action_plan_note: 'オフィス',
    issues: '手配＋新規スタッフ稼働',
    business_details: '新規什器搬入（4t×2台・2t×1台）・開梱・組立補助作業',
    impressions:
        '先週と同じ現場だったので、また同じ物量があるのかと身構えていましたが、かなり少なかったです。机の数がない分、天板が少なかったのでそれが大きかったです。',
    business_improvement_points: '特になし'
};
export default {
    namespaced: true,
    state: {
        data: JSON.parse(JSON.stringify(initData)),
        optionGroup: {
            type: [
                { code: 1, name: '現場' },
                { code: 2, name: 'オフィス' }
            ],
            office: [
                { code: 1, name: '出勤' },
                { code: 2, name: '公休' }
            ],
            workday_title: [
                { code: 1, name: '出勤' },
                { code: 2, name: '公休' }
            ],
            workday_number: [{ code: 1, name: '1' }],
            onsite_meetings: [
                { code: 1, name: '仕事の心得使用', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                { code: 2, name: '朝礼（点呼・制服備品確認・現場前ＭＴＧ）' }
                // { code: 3, name: '昼礼（点呼・昼ＭＴＧ）', note: '※ショート現場の場合' },
                // { code: 4, name: '有り' },
                // { code: 5, name: '無し' },
                // { code: 6, name: '終礼（点呼・終了報告・現場後ＭＴＧ）', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                // { code: 7, name: '一人現場のため未実施' }
            ],
            onsite_meetings2: [
                { code: 4, name: '終礼（点呼・終了報告・現場後ＭＴＧ）', note: '※未使用の場合は経緯を【作業内容・所感】で報告' },
                { code: 5, name: '一人現場のため未実施' }
            ],
            business_partners: [
                { code: 1, name: '名刺交換', note: '※後日、上長報告（eightに転記）' },
                { code: 2, name: '終了報告' }
            ],
            yes_no_option: [
                { code: 1, name: 'あり' },
                { code: 2, name: 'なし' }
            ],
            daytime: [
                { code: 1, name: '有り' },
                { code: 2, name: '無し' }
            ],
            type_table: [
                { code: 1, name: '現場' },
                { code: 2, name: 'オフィス' },
                { code: 3, name: '営業' }
            ]
        }
    },
    mutations: {
        resetFormData(state) {
            state.data = JSON.parse(JSON.stringify(initData));
        },
        changeTypeState(state, type) {
            state.data.type = type;
        },
        setMeiShoCd(state, data) {
            ['workday_title'].forEach((key) => {
                state.optionGroup[key] = [];
            });

            const listMeiSho = data || [];

            listMeiSho.forEach((item) => {
                const option = {
                    code: item.code,
                    name: item.name
                };

                switch (Number(item.name_cd)) {
                    case 200:
                        state.optionGroup.workday_title.push(option);
                        break;
                    default:
                        break;
                }
            });
        },
        setListData(state, list) {
            state.data.general = list.general ?? {};
            state.data.time_schedule = list.time_schedule ?? [];
            state.data.sites = [];

            const onsite_tabs = list.onsite_tabs ?? [];
            const office_tabs = list.office_tabs ?? [];

            const sales_tabs = list.sales_tabs ?? [];
            const client_staff = list.client_staff ?? [];
            const past_sales_records = list.past_sales_records ?? [];

            let sites = [];
            let autoId = 1;
            let idxOnsite = 1;
            let idxOffice = 1;
            let idxSales = 1;

            // ===== helpers =====
            const toCheckedArray = (row, prefix, from, to) => {
                const out = [];
                for (let i = from; i <= to; i++) {
                    if (row[`${prefix}${i}`] == 1) out.push(String(i));
                }
                return out;
            };

            const makeClientBranchKey = (row) => {
                const client = String(row?.ClientCD ?? '');
                const branch = String(row?.BranchCD ?? '');
                return `${client}_${branch}`;
            };

            const groupByClient = (rows) => {
                const map = Object.create(null);
                for (const r of rows) {
                    const k = makeClientBranchKey(r);
                    (map[k] ||= []).push(r);
                }
                return map;
            };

            // ===== onsite =====
            for (const item of onsite_tabs) {
                sites.push({
                    id: autoId++,
                    type: 1,
                    index_type: idxOnsite++,
                    OnSiteMTGGr1: toCheckedArray(item, 'OnSiteMTGCHK', 1, 2),
                    OnSiteMTGGr2: toCheckedArray(item, 'OnSiteMTGCHK', 4, 5),
                    OnSiteClient: toCheckedArray(item, 'ClientCHK', 1, 2),
                    ...item
                });
            }

            // ===== office =====
            for (const item of office_tabs) {
                sites.push({
                    id: autoId++,
                    type: 2,
                    index_type: idxOffice++,
                    ...item
                });
            }

            // ===== sales (merge 5-6-7) =====
            const staffMap = groupByClient(client_staff);
            const pastMapFull = groupByClient(past_sales_records);

            // precompute: totalRows + take first 5
            const pastMeta = Object.create(null);
            for (const key of Object.keys(pastMapFull)) {
                const items = pastMapFull[key] || [];
                pastMeta[key] = {
                    totalRows: items.length,
                    items: items.slice(0, 5)
                };
            }

            for (const row of sales_tabs) {
                const key = makeClientBranchKey(row);
                const meta = pastMeta[key] || { totalRows: 0, items: [] };

                sites.push({
                    id: autoId++,
                    type: 3,
                    index_type: idxSales++,

                    ...row,

                    // normalize SalesNoteCheck "1,3,5" -> ["1","3","5"]
                    SalesNoteCheck:
                        typeof row.SalesNoteCheck === 'string' && row.SalesNoteCheck.length
                            ? row.SalesNoteCheck.split(',')
                                  .map((s) => s.trim())
                                  .filter(Boolean)
                            : [],

                    client_staff: (staffMap[key] || []).map((s) => ({
                        ...s,
                        TabNo: row.TabNo ?? ''
                    })),

                    past_sales_records: (meta.items || []).map((x) => ({ ...x })),

                    paginationData: {
                        pageNo: 1,
                        pageSize: 5,
                        totalRows: meta.totalRows,
                        msgNoData: '該当するデータが存在しません。'
                    }
                });
            }

            state.data.sites = sites;
        }
    },
    actions: {
        getData(context, body) {
            try {
                repository.getData(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const list = data.Data ?? [];
                        context.commit('setListData', list);
                        if (body.callback) {
                            body.callback();
                        }
                    }
                });
            } catch (e) {
                console.log('searchCustomerInfo: ' + e.message);
            }
        },
        getOrderDetail(context, body) {
            try {
                repository.getOrderDetail(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('searchCustomerInfo: ' + e.message);
            }
        },
        getComments(context, body) {
            try {
                repository.getComments(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getComments: ' + e.message);
            }
        },
        storeComment(context, input) {
            try {
                repository.storeComment(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Message || data.Data?.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action storeComment: ' + e.message);
            }
        },
        deleteComment(context, input) {
            try {
                repository.deleteComment(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data.Data);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Message || data.Data?.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action storeComment: ' + e.message);
            }
        },
        getMentions(context, body) {
            try {
                repository.getMentions(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getMentions: ' + e.message);
            }
        },
        searchPastSalesReport(context, request) {
            try {
                repository.searchPastSalesReport(request.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (request.callback) {
                            request.callback(data.Data.list);
                        }
                    } else if (request.onError) {
                        request.onError(data.Message || data.Data?.message);
                    }
                });
            } catch (e) {
                console.log('Search: ' + e.message);
            }
        },
        saveData(context, input) {
            try {
                repository.saveData(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Message || data.Data?.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action save staff info: ' + e.message);
            }
        }
    }
};
